
import ns from 'ns';
const fr = require('../../lang/default.fr.json');
const en = require('../../lang/default.en.json');

// console.log(fr);
const lang = ns.lang;

const translations = lang === 'en' ? en : fr;
translations.basePath = ns.basePath;
translations.lang = lang;

export default translations;
